import type { StaticEntityType } from "@config";
import { useMemo } from "react";
import { TickerCtxProvider } from "../ctx";
import type { ITickerItem } from "../types";
import { ensureTickerElementSettings } from "../utils";
import { TickerItem } from "./ticker-item";

interface IProps {
  entity: StaticEntityType;
}

const ITEMS_PER_ROW = 4;

export const TickerPdf = ({ entity }: IProps) => {
  const elementSettings = useMemo(() => {
    return ensureTickerElementSettings(entity.settings);
  }, [entity.settings]);

  const rows: ITickerItem[][] = [];
  elementSettings.tickerItems.forEach((item, idx) => {
    if (idx % ITEMS_PER_ROW === 0) rows.push([]);

    rows[rows.length - 1].push(item);
  });

  return (
    <TickerCtxProvider
      ctxState={{
        isHorizontal: true,
        isVertical: false,
        elementSettings,
        shouldAnimate: false,
        isAnimReverse: false,
      }}
    >
      <div className="ticker-pdf tw-block tw-w-full">
        {rows.map((items, ri) => (
          <div
            key={ri}
            className="tw-grid tw-break-inside-avoid"
            style={{
              gridTemplateColumns: `repeat(${ITEMS_PER_ROW}, 1fr)`,
              gap: elementSettings.tickerItemsSpacing + "px",
              marginTop: ri > 0 ? elementSettings.tickerItemsSpacing + "px" : 0,
            }}
          >
            {items.map((item, ii) => (
              <TickerItem key={ii} item={item} idx={ii} isVisible={true} />
            ))}
          </div>
        ))}
      </div>
    </TickerCtxProvider>
  );
};
